import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { PaymentStatus, PaymentStatusVariant } from '@shared/models/payment-status';
import { TranslateService } from '@ngx-translate/core';
import { CpcPayment } from '@shared/models/cpc-payment';
import { LocaleService } from '@core/services/locale.service';
import { CommonService } from '@core/services/common.service';

@Component({
    selector: 'app-premium-list-paged',
    templateUrl: './premium-list-paged.component.html',
    styleUrls: ['./premium-list-paged.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PremiumListPagedComponent implements OnInit {
    @Input() premiumList: CpcPayment[];
    @Input() variant: string;

    readonly paymentStatus: typeof PaymentStatus = PaymentStatus;
    readonly paymentStatusVariant: typeof PaymentStatusVariant = PaymentStatusVariant;

    public activePage = 1;
    public perPage = 5;
    public maxPage = 0;
    public premiumColLabels = {
        status: '',
        due: '',
        date: '',
        method: '',
        amount: ''
    };

    public canBePayed = true;

    constructor(
        private localeService: LocaleService,
        private translateService: TranslateService,
        private commonService: CommonService,
    ) {
    }

    ngOnInit(): void {
        this.localeService.activeLanguage.subscribe(language => this.translatePremiumColLabels());

        this.premiumList.map((x) => {
            if (this.variant == 'upcoming' && x.canBePayed != undefined && x.canBePayed === false) {
                this.canBePayed = false;
            }
        });

    }


    ngAfterViewInit() {
        this.updatePaymentsAppearence();
        this.paymentsPaginationActions();
    }

    private paymentsPaginationActions() {
        const pagination = document.querySelector('cpc-pagination');
        if (!pagination) {
            return;
        }

        const prevBtn = pagination.querySelector('.cpc-pagination-nav-prev');
        const nextBtn = pagination.querySelector('.cpc-pagination-nav-next');

        if (prevBtn) {
            prevBtn.addEventListener('click', () => { this.updatePaymentsAppearence(); });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => { this.updatePaymentsAppearence(); });
        }

        const itemsPerPage = pagination.querySelector('cpc-select');
        if (itemsPerPage) {
            itemsPerPage.addEventListener('click', () => {
                itemsPerPage.querySelectorAll('.cpc-select-dropdown-items-item').forEach(x => {
                    x.addEventListener('click', () => {
                        this.updatePaymentsAppearence();
                    });
                });
            });
        }
    }

    private updatePaymentsAppearence() {

        if (document.querySelector('[data-type=upcoming]')) {
            let a = document.querySelector('[data-type=upcoming]').querySelectorAll('cpc-payment-row');
            if (a.length > 0) {

                a.forEach(item => {
                    if (this.canBePayed === false) {
                        let btn = item.querySelector('.cpc-payment-row-pay').querySelector('cpc-button');
                        if (btn) {
                            btn.remove();
                        }

                    } else {
                        const maturityDate = item.querySelector('span[due]').firstChild.textContent.split('.');
                        const maturityDateConcated = maturityDate[2] + '-' + maturityDate[1] + '-' + maturityDate[0];
                        if (this.commonService.compareMaturityDate(maturityDateConcated)) {
                            const payBtn = item.querySelector('.cpc-payment-row-pay').querySelector('cpc-button');
                            if (payBtn) {
                                payBtn.setAttribute('class', 'green2');
                            }
                        }
                    }
                });
            }
        }
    }

    translatePremiumColLabels(): void {
        // Why instant is not working?
        this.translateService.get('policy.payments.status').subscribe((res: string) => this.premiumColLabels.status = res);
        this.translateService.get('policy.payments.due-date').subscribe((res: string) => this.premiumColLabels.due = res);
        this.translateService.get('policy.payments.payment-date').subscribe((res: string) => this.premiumColLabels.date = res);
        this.translateService.get('policy.payments.payment-method').subscribe((res: string) => this.premiumColLabels.method = res);
        this.translateService.get('policy.payments.amount').subscribe((res: string) => this.premiumColLabels.amount = res);
    }

    clickPay($event) {
        window.open($event.gatewayPaymentUrl, '_blank');
    }
}
